import { AuthProvider } from './Auth';
import { DemoListProvider } from './DemoList';
import { MerchantProvider } from './Merchant';

export function AppProvider({ children }: any) {
  return (
    <AuthProvider>
      <MerchantProvider>
        <DemoListProvider>{children}</DemoListProvider>
      </MerchantProvider>
    </AuthProvider>
  );
}
